var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.58.52a.75.75 0 00-1.06-.1l-6 5a.75.75 0 000 1.16l6 5a.75.75 0 10.96-1.16L2.18 6l5.3-4.42a.75.75 0 00.1-1.06z","fill":"#848484"}));
}

ArrowLeft.defaultProps = {"className":"md:u-mr-sm","width":"8","height":"12","viewBox":"0 0 8 12","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
